import {ServerError as ApolloServerError} from "@apollo/client";


class PortError extends Error {
    constructor(message) {
        super(message);
        this.message = message;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}


export class NetworkError extends PortError {
    constructor() {
        super("Нет соединения");
    }
}


export class ServerError extends PortError {
    constructor(message) {
        super(message || "Ошибка сервера");
    }
}


export class LogicError extends ServerError {
    public readonly code: string;
    public readonly description: string;

    constructor(message, code, description) {
        super(message);
        this.code = code;
        this.description = description;
    }
}


export class ServerTemporarilyUnavailable extends ServerError {
    constructor(message) {
        super(message);
    }
}